import React, { useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Paper,
/*   IconButton, */
  TextField,
  Typography,
} from "@mui/material";
/* import VisibilityIcon from "@mui/icons-material/Visibility";
import InsertChartIcon from "@mui/icons-material/InsertChart"; */

// Soporta {$numberDecimal: "..."} y otros objetos
const formatCell = (value) => {
  if (typeof value === "object" && value !== null) {
    if ("$numberDecimal" in value) return value.$numberDecimal;
    return JSON.stringify(value);
  }
  return value;
};

const TableMUI = ({
  title = "Título",
  data = [],
  columns = [], // <--- ahora usamos esto
}) => {
  const [filtro, setFiltro] = useState("");

  // Filtro por texto en columnas activas
  const filteredRows = data.filter((row) =>
    columns.some((col) =>
      ((formatCell(row[col.key]) ?? '').toString()
        .toLowerCase()
        .includes(filtro.toLowerCase()))
    )
  );

  return (
    <Box p={3}>
      <Typography variant="h6" gutterBottom>
        <strong>{title}</strong>
      </Typography>

      <TextField
        label="Buscar..."
        variant="outlined"
        size="small"
        fullWidth
        margin="normal"
        value={filtro}
        onChange={(e) => setFiltro(e.target.value)}
      />

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key}>{col.header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.map((row, index) => (
              <TableRow key={index}>
                {columns.map((col) => (
                  <TableCell key={col.key}>
                    {formatCell(row[col.key])}
                  </TableCell>
                ))}
                {/* <TableCell>
                  <IconButton>
                    <InsertChartIcon />
                  </IconButton>
                  <IconButton>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell> */}
              </TableRow>
            ))}
            {filteredRows.length === 0 && (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                  No hay resultados
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableMUI;
